// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__38GWj","resendInfoText":"OnGoingPaymentBox_resendInfoText__37uPF"};